import {
  Button,
  Flex,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@ritualco/jutsu'
import 'react-multi-email/style.css'
import * as Yup from 'yup'
import { Form, Formik, FormikConfig } from 'formik'
import { FormikInput } from 'components/Formik'
import { useContent } from '../../../lib/content/react'
import { ConnectionAccessCodeModalProps } from './types'
import { HeraModal } from 'components/HeraModal'
import { useMessage } from 'contexts/MessageContext'

export const ConnectionAccessCodeModal = ({
  onSubmit,
  onClose,
  isOpen,
  accessCode = '',
}: ConnectionAccessCodeModalProps) => {
  const { formatMessage } = useContent()
  const { addError } = useMessage()
  const FormValueTypeSchema = Yup.object().shape({
    accessCode: Yup.string().required(
      formatMessage({ id: 'pmportal.connections.error.required' })
    ),
  })

  const handleSubmit: FormikConfig<{ accessCode: string }>['onSubmit'] = async (
    values,
    actions
  ) => {
    try {
      await onSubmit(values.accessCode)
      onClose()
    } catch (err) {
      switch (err.status) {
        case 400:
        case 401:
        case 403:
          actions.setFieldError(
            'accessCode',
            formatMessage({ id: 'pmportal.connections.error.invalid' })
          )
          break
        default:
          addError({
            description: formatMessage({
              id: 'pmportal.error.unknown',
            }),
          })
      }
    } finally {
      actions.setSubmitting(false)
    }
  }

  return (
    <HeraModal size="xl" isOpen={isOpen} onClose={onClose} isCentered={true}>
      <Formik
        initialValues={{ accessCode }}
        validationSchema={FormValueTypeSchema}
        onSubmit={handleSubmit}
      >
        {props => (
          <>
            <ModalHeader>
              {formatMessage({ id: 'pmportal.connections.addCodeHeader' })}
            </ModalHeader>
            <ModalBody>
              <Form id="connectionAccessCode">
                <Flex direction="column">
                  <Text
                    fontSize="small"
                    color="grayscale.secondary"
                    pt={1}
                    mt={-5}
                    mb={6}
                  >
                    {formatMessage({
                      id: 'pmportal.connections.addCodeDesc',
                    })}
                  </Text>
                  <FormikInput
                    label={formatMessage({
                      id: 'pmportal.connections.addCodeInputLabel',
                    })}
                    placeholder={formatMessage({
                      id: 'pmportal.connections.addCodeInputPlaceholder',
                    })}
                    name="accessCode"
                    isRequired
                  />
                </Flex>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="transparent" mr={2} onClick={onClose}>
                {formatMessage({ id: 'pmportal.global.actionCancel' })}
              </Button>
              <Button
                type="submit"
                form="connectionAccessCode"
                isLoading={props.isSubmitting}
              >
                {formatMessage({
                  id: 'pmportal.connections.addCodeSubmit',
                })}
              </Button>
            </ModalFooter>
          </>
        )}
      </Formik>
    </HeraModal>
  )
}
